import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from '../../../services/types/filter.types';
import { emailMessageAttachmentGridItemFrag } from './types/email-message-attachment.gql-types';
import { EmailMessageAttachmentGridObject } from '@libs/types/src/inbox/object-type/email-message-attachment.object';

@Injectable({ providedIn: 'root' })
export class EmailMessageAttachmentGqlService extends GqlServiceV2 {

    getEmailMessageAttachments(input: GridInput, frag: string = emailMessageAttachmentGridItemFrag) {
        return this.query<EmailMessageAttachmentGridObject>(
            `
                query($input: GridInput!) {
                    emailMessageAttachment {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }
}
